import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import s from "../Color.js";
import t from "../request.js";
import r from "../core/Error.js";
import { clone as i } from "../core/lang.js";
import o from "../core/Logger.js";
import n from "../core/LRUCache.js";
import { isSome as a } from "../core/maybe.js";
import { isAbortError as l } from "../core/promiseUtils.js";
import { numericHash as c } from "../core/string.js";
import { property as p } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as m } from "../core/accessorSupport/decorators/subclass.js";
import { writer as u } from "../core/accessorSupport/decorators/writer.js";
import { collectArcadeFieldNames as f } from "../layers/support/fieldUtils.js";
import h from "./Renderer.js";
import { VisualVariablesMixin as y } from "./mixins/VisualVariablesMixin.js";
import { loadArcade as d, createDictionaryExpression as g } from "../support/arcadeOnDemand.js";
import b from "../symbols/CIMSymbol.js";

var _2;

var j = o.getLogger("esri.renderers.DictionaryRenderer"),
    w = {
  type: "CIMSimpleLineCallout",
  lineSymbol: {
    type: "CIMLineSymbol",
    symbolLayers: [{
      type: "CIMSolidStroke",
      width: .5,
      color: [0, 0, 0, 255]
    }]
  }
};

var S = _2 = /*#__PURE__*/function (_y) {
  _inherits(_, _y);

  var _super = _createSuper(_);

  function _(e) {
    var _this;

    _classCallCheck(this, _);

    _this = _super.call(this, e), _this._ongoingRequests = new Map(), _this._symbolCache = new n(100), _this.config = null, _this.fieldMap = null, _this.scaleExpression = null, _this.scaleExpressionTitle = null, _this.url = null, _this.type = "dictionary";
    return _this;
  }

  _createClass(_, [{
    key: "writeData",
    value: function writeData(e, s) {
      e && (s.scalingExpressionInfo = {
        expression: e,
        returnType: "number"
      });
    }
  }, {
    key: "writeVisualVariables",
    value: function writeVisualVariables(e, s, t, r) {
      null != r && r.origin || _get(_getPrototypeOf(_.prototype), "writeVisualVariables", this).call(this, e, s, t, r);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _2({
        config: i(this.config),
        scaleExpression: this.scaleExpression,
        scaleExpressionTitle: this.scaleExpressionTitle,
        fieldMap: i(this.fieldMap),
        url: i(this.url),
        visualVariables: i(this.visualVariables)
      });
    }
  }, {
    key: "getSymbolAsync",
    value: function () {
      var _getSymbolAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t) {
        var _this2 = this;

        var r, i, _iterator, _step, _s, _t, _r, o, n, p, m, u, f, _iterator2, _step2, _a, _iterator3, _step3, _e, _e2, _t2, _r2, _i, _e3, h, y;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._dictionaryPromise || (this._dictionaryPromise = this.fetchResources(t));
                _context.prev = 1;
                _context.next = 4;
                return this._dictionaryPromise;

              case 4:
                r = _context.sent;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](1);

                if (!l(_context.t0)) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", (this._dictionaryPromise = null, null));

              case 11:
                i = {};

                if (this.fieldMap) {
                  _iterator = _createForOfIteratorHelper(this._symbolFields);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      _s = _step.value;
                      _t = this.fieldMap[_s];

                      if (_t && null !== e.attributes[_t] && void 0 !== e.attributes[_t]) {
                        _r = "" + e.attributes[_t];
                        i[_s] = _r;
                      } else i[_s] = "";
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }

                o = r(i, t);

                if (!(!o || "string" != typeof o)) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return", null);

              case 16:
                n = c(o).toString(), p = this._symbolCache.get(n);

                if (!p) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return", (p.catch(function () {
                  _this2._symbolCache.pop(n);
                }), p));

              case 19:
                m = o.split(";"), u = [], f = [];
                _iterator2 = _createForOfIteratorHelper(m);
                _context.prev = 21;

                _iterator2.s();

              case 23:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 55;
                  break;
                }

                _a = _step2.value;

                if (!(_a && 0 !== _a.length)) {
                  _context.next = 53;
                  break;
                }

                if (!(-1 === _a.indexOf("po:"))) {
                  _context.next = 51;
                  break;
                }

                if (!(-1 !== _a.indexOf("|"))) {
                  _context.next = 48;
                  break;
                }

                _iterator3 = _createForOfIteratorHelper(_a.split("|"));
                _context.prev = 29;

                _iterator3.s();

              case 31:
                if ((_step3 = _iterator3.n()).done) {
                  _context.next = 38;
                  break;
                }

                _e = _step3.value;

                if (!this._itemNames.has(_e)) {
                  _context.next = 36;
                  break;
                }

                u.push(_e);
                return _context.abrupt("break", 38);

              case 36:
                _context.next = 31;
                break;

              case 38:
                _context.next = 43;
                break;

              case 40:
                _context.prev = 40;
                _context.t1 = _context["catch"](29);

                _iterator3.e(_context.t1);

              case 43:
                _context.prev = 43;

                _iterator3.f();

                return _context.finish(43);

              case 46:
                _context.next = 49;
                break;

              case 48:
                this._itemNames.has(_a) && u.push(_a);

              case 49:
                _context.next = 53;
                break;

              case 51:
                _e2 = _a.substr(3).split("|");

                if (3 === _e2.length) {
                  _t2 = _e2[0], _r2 = _e2[1];
                  _i = _e2[2];
                  if ("DashTemplate" === _r2) _i = _i.split(" ").map(function (e) {
                    return Number(e);
                  });else if ("Color" === _r2) {
                    _e3 = new s(_i).toRgba();
                    _i = [_e3[0], _e3[1], _e3[2], 255 * _e3[3]];
                  } else _i = Number(_i);
                  f.push({
                    primitiveName: _t2,
                    propertyName: _r2,
                    value: _i
                  });
                }

              case 53:
                _context.next = 23;
                break;

              case 55:
                _context.next = 60;
                break;

              case 57:
                _context.prev = 57;
                _context.t2 = _context["catch"](21);

                _iterator2.e(_context.t2);

              case 60:
                _context.prev = 60;

                _iterator2.f();

                return _context.finish(60);

              case 63:
                h = !a(e.geometry) || !e.geometry.hasZ && "point" === e.geometry.type, y = this._cimPartsToCIMSymbol(u, f, h, t);
                return _context.abrupt("return", (this._symbolCache.put(n, y, 1), y));

              case 65:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 7], [21, 57, 60, 63], [29, 40, 43, 46]]);
      }));

      function getSymbolAsync(_x, _x2) {
        return _getSymbolAsync.apply(this, arguments);
      }

      return getSymbolAsync;
    }()
  }, {
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, s) {
        var _t3, r;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.collectVVRequiredFields(e, s);

              case 2:
                _context2.t0 = this.scaleExpression;

                if (!_context2.t0) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return f(e, s, this.scaleExpression);

              case 6:
                for (_t3 in this.fieldMap) {
                  r = this.fieldMap[_t3];
                  s.has(r) && e.add(r);
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function collectRequiredFields(_x3, _x4) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }, {
    key: "arcadeRequired",
    get: function get() {
      return !0;
    }
  }, {
    key: "fetchResources",
    value: function () {
      var _fetchResources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var _this3 = this;

        var s, i, _yield$Promise$all, _yield$Promise$all2, o, n, l, c, _e4, _s2, _iterator4, _step4, _t4, p, _iterator5, _step5, _loop;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this._dictionaryPromise) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", this._dictionaryPromise);

              case 2:
                if (this.url) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", void j.error("no valid URL!"));

              case 4:
                s = a(e) ? e.abortOptions : null;
                i = t(this.url + "/resources/styles/dictionary-info.json", _objectSpread({
                  responseType: "json",
                  query: {
                    f: "json"
                  }
                }, s));
                _context3.next = 8;
                return Promise.all([i, d()]);

              case 8:
                _yield$Promise$all = _context3.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
                o = _yield$Promise$all2[0].data;

                if (o) {
                  _context3.next = 13;
                  break;
                }

                throw this._dictionaryPromise = null, new r("esri.renderers.DictionaryRenderer", "Bad dictionary data!");

              case 13:
                n = o.expression, l = o.authoringInfo;
                this._refSymbolUrlTemplate = this.url + "/" + o.cimRefTemplateUrl, this._itemNames = new Set(o.itemsNames), this._symbolFields = l.symbol;
                c = {};

                if (this.config) {
                  _e4 = this.config;

                  for (_s2 in _e4) {
                    c[_s2] = _e4[_s2];
                  }
                }

                if (l.configuration) {
                  _iterator4 = _createForOfIteratorHelper(l.configuration);

                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      _t4 = _step4.value;
                      c.hasOwnProperty(_t4.name) || (c[_t4.name] = _t4.value);
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }
                }

                p = [];

                if (a(e) && e.fields && this.fieldMap) {
                  _iterator5 = _createForOfIteratorHelper(this._symbolFields);

                  try {
                    _loop = function _loop() {
                      var t = _step5.value;
                      var s = _this3.fieldMap[t],
                          r = e.fields.filter(function (e) {
                        return e.name === s;
                      });
                      r.length > 0 && p.push(_objectSpread(_objectSpread({}, r[0]), {}, {
                        name: t
                      }));
                    };

                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                      _loop();
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                }

                return _context3.abrupt("return", (this._dictionaryPromise = g(n, a(e) ? e.spatialReference : null, p, c).then(function (e) {
                  var s = {
                    scale: 0
                  };
                  return function (t, r) {
                    var i = e.repurposeFeature({
                      geometry: null,
                      attributes: t
                    });
                    return s.scale = a(r) ? r.scale : void 0, e.evaluate({
                      $feature: i,
                      $view: s
                    });
                  };
                }).catch(function (e) {
                  return j.error("Creating dictinoary expression failed:", e), null;
                }), this._dictionaryPromise));

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchResources(_x5) {
        return _fetchResources.apply(this, arguments);
      }

      return fetchResources;
    }()
  }, {
    key: "getSymbol",
    value: function getSymbol() {
      return null;
    }
  }, {
    key: "getSymbols",
    value: function getSymbols() {
      return [];
    }
  }, {
    key: "getAttributeHash",
    value: function getAttributeHash() {
      return this.visualVariables && this.visualVariables.reduce(function (e, s) {
        return e + s.getAttributeHash();
      }, "");
    }
  }, {
    key: "getMeshHash",
    value: function getMeshHash() {
      return "".concat(this.url, "-").concat(JSON.stringify(this.fieldMap));
    }
  }, {
    key: "getSymbolFields",
    value: function getSymbolFields() {
      return this._symbolFields;
    }
  }, {
    key: "_getSymbolPart",
    value: function () {
      var _getSymbolPart2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, s) {
        var r, i;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this._ongoingRequests.has(e)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", this._ongoingRequests.get(e).then(function (e) {
                  return e.data;
                }));

              case 2:
                r = this._refSymbolUrlTemplate.replace(/\{itemName\}/gi, e), i = t(r, _objectSpread({
                  responseType: "json",
                  query: {
                    f: "json"
                  }
                }, s));

                this._ongoingRequests.set(e, i);

                _context4.prev = 4;
                _context4.next = 7;
                return i;

              case 7:
                return _context4.abrupt("return", _context4.sent.data);

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](4);
                return _context4.abrupt("return", (this._ongoingRequests.delete(e), Promise.reject(_context4.t0)));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 10]]);
      }));

      function _getSymbolPart(_x6, _x7) {
        return _getSymbolPart2.apply(this, arguments);
      }

      return _getSymbolPart;
    }()
  }, {
    key: "_combineSymbolParts",
    value: function _combineSymbolParts(e, s, t) {
      if (!e || 0 === e.length) return null;

      var r = _objectSpread({}, e[0]);

      if (e.length > 1) {
        r.symbolLayers = [];

        var _iterator6 = _createForOfIteratorHelper(e),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _r$symbolLayers;

            var _s3 = _step6.value;
            var _e5 = _s3;

            (_r$symbolLayers = r.symbolLayers).unshift.apply(_r$symbolLayers, _toConsumableArray(_e5.symbolLayers));
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }

      return t && (r.callout = w), {
        type: "CIMSymbolReference",
        symbol: r,
        primitiveOverrides: s
      };
    }
  }, {
    key: "_cimPartsToCIMSymbol",
    value: function () {
      var _cimPartsToCIMSymbol2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e, s, t, r) {
        var i, _n, o;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                i = new Array(e.length);

                for (_n = 0; _n < e.length; _n++) {
                  i[_n] = this._getSymbolPart(e[_n], r);
                }

                _context5.next = 4;
                return Promise.all(i);

              case 4:
                o = _context5.sent;
                return _context5.abrupt("return", new b({
                  data: this._combineSymbolParts(o, s, t)
                }));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _cimPartsToCIMSymbol(_x8, _x9, _x10, _x11) {
        return _cimPartsToCIMSymbol2.apply(this, arguments);
      }

      return _cimPartsToCIMSymbol;
    }()
  }]);

  return _;
}(y(h));

e([p({
  type: Object,
  json: {
    read: {
      source: "configuration"
    },
    write: {
      target: "configuration"
    }
  }
})], S.prototype, "config", void 0), e([p({
  type: Object,
  json: {
    write: !0
  }
})], S.prototype, "fieldMap", void 0), e([p({
  type: String,
  json: {
    read: {
      source: "scalingExpressionInfo.expression"
    },
    write: !0
  }
})], S.prototype, "scaleExpression", void 0), e([u("scaleExpression")], S.prototype, "writeData", null), e([p({
  type: String,
  json: {
    read: {
      source: "scalingExpressionInfo.title"
    },
    write: {
      target: "scalingExpressionInfo.title",
      overridePolicy: function overridePolicy(e) {
        return {
          enabled: !!e && !!this.scaleExpression
        };
      }
    }
  }
})], S.prototype, "scaleExpressionTitle", void 0), e([p({
  type: String,
  json: {
    write: !0
  }
})], S.prototype, "url", void 0), e([u("visualVariables")], S.prototype, "writeVisualVariables", null), S = _2 = e([m("esri.renderers.DictionaryRenderer")], S);
var x = S;
export { x as default };